// src/hooks/useMagnific.js
import { useEffect } from "react";
export const useMagnific = () => {
  useEffect(() => {
    if (!window.jQuery?.fn?.magnificPopup) return;
    window.jQuery(".js-projects-gallery").magnificPopup({
      delegate: "a",
      type: "image",
      gallery: { enabled: true, navigateByImgClick: true, preload: [0, 1] },
      image: {
        titleSrc: (item) => item.el.attr("title"),
      },
    });
  }, []);
};
export default useMagnific;
